/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { AUTH0_NAMESPACE } from './constants';

const hasWildfirePermissionsSelector = (user: any): boolean =>
  user?.[`${AUTH0_NAMESPACE}/roles`]?.includes('wfPermissions');

const isSuperAdminSelector = (user: any): boolean => user?.[`${AUTH0_NAMESPACE}/roles`]?.includes('wf_superadmin');
const userRolesSelector = (user: any): string[] => user?.[`${AUTH0_NAMESPACE}/roles`];

// accessTokenPermissions reads the permissions claim from the Auth0 access token. It only hides
// controls the user can't use: the backend checks the same claim, returns its own errors, and is the
// real boundary. Any failure here fails closed (no permissions), with a warning to help debugging.
const accessTokenPermissions = (accessToken: string): string[] => {
  try {
    const payload = accessToken.split('.')[1];
    if (!payload) {
      if (accessToken) console.warn('accessTokenPermissions: access token has no payload');
      return [];
    }
    const claims = JSON.parse(atob(payload.replace(/-/g, '+').replace(/_/g, '/')));
    if (!Array.isArray(claims?.permissions)) {
      console.warn('accessTokenPermissions: access token has no permissions claim');
      return [];
    }
    return claims.permissions;
  } catch (error) {
    console.warn('accessTokenPermissions: could not decode the access token', error);
    return [];
  }
};

const USERS_IDENTITIES_MAP: {
  [key: string]: string;
} = {
  'Username-Password-Authentication': 'Email',
  'google-oauth2': 'Google / Gmail',
};

export {
  hasWildfirePermissionsSelector,
  isSuperAdminSelector,
  userRolesSelector,
  accessTokenPermissions,
  USERS_IDENTITIES_MAP,
};
